import * as React from 'react';
import { SVGProps } from 'react';

const IconMBUSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 2.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H7L4.23 17H2.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5H6v5.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V20h10v5.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5V20h3.5a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H24v-4.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5V17h-1.23L13 5h1.5a.5.5 0 0 0 .5-.5v-2ZM19 17h3v-2h-3v2Zm-6.23 0H7.23l2.078-9h1.384l2.077 9Z"
    />
  </svg>
);
export default IconMBUSizeL;
